import { useEffect, useRef } from "react";
import { gsap } from "../../lib/gsap";

export default function AutonomyDriveIntro() {
  const marqueeRef = useRef(null);

  useEffect(() => {
    gsap.to(marqueeRef.current, {
      xPercent: -50,
      ease: "none",
      duration: 20,
      repeat: -1,
    });
  }, []);

  return (
    <section className="relative bg-slate-950 text-white py-24 overflow-hidden">

      {/* Background Moving Text */}
      <div className="absolute inset-0 flex items-center opacity-[0.05] pointer-events-none">
        <div
          ref={marqueeRef}
          className="whitespace-nowrap text-[120px] font-semibold tracking-widest"
        >
          AUTONOMOUS BRAKING • PEDESTRIAN DETECTION • REAL-TIME PERCEPTION • SAFETY SYSTEMS •
          AUTONOMOUS BRAKING • PEDESTRIAN DETECTION • REAL-TIME PERCEPTION • SAFETY SYSTEMS •
        </div>
      </div>

      {/* Foreground Content */}
      <div className="relative max-w-6xl mx-auto px-6 text-center space-y-6">
        <h2 className="text-3xl md:text-5xl font-semibold">
          Autonomous Braking Intelligence
        </h2>

        <p className="text-slate-400 max-w-2xl mx-auto text-base md:text-lg">
          Our perception engine detects pedestrians in real time and
          dynamically engages deterministic braking control to ensure
          safe, predictable vehicle behavior in complex environments.
        </p>
      </div>
    </section>
  );
}